<template>
  <div style="height: 100%;width:100%;position: relative">
    <div ref="map" style="height: 100%;width:100%;position: relative" @click="handldGetMousePos($event)">
    </div>
    <div class="map-click-tc" v-show="ismap" ref="maptc"
         style="position: absolute; left: 0;top: 0; pointer-events: all; z-index: 10000;background-color: #ffe6c4;box-shadow: 3px 4px 14px 1px; rgba(159, 97, 0, 0.5);border-radius: 8px;border: solid 1px #c2894c;padding: 5px;box-sizing: border-box">
      <div style="font-size: 16px;color: #990000;text-align: left;font-weight: bold;margin-bottom: 10px;">{{region}}
      </div>
      <ul class="roll roll-ul" @mouseenter="mousewheel(true)" @mouseleave="mousewheel(false)">
        <li class="roll-li" v-for="(item,index) in  listofcities" @mouseenter="handleEnter(item)"
            @mouseleave="handleLeave(item)" style="display: flex;justify-content: space-between">
          <span :class="[item.dl ? 'ly-icon-dl':'ly-icon-wdl']"
                style=";display: inline-block; background-size: 100% 100%; width: 10%; height: 27px; vertical-align: baseline;"></span>
          <span class="ly-name product-buyer-name" :title="item.mmshName"
                style="text-align: left; display: inline-block;width: 55%; height: 23px;line-height: 23px;font-family: MicrosoftYaHei;font-size: 16px;font-weight: normal;font-stretch: normal;letter-spacing: 1px;color: #990000;margin-right: 16px;margin-left: 7px;">{{item.mmshName}}</span>
          <span class="ly-dl" @click="handleLittleStar(item)"
                style="display: inline-block;width: 20%;height: 22px; background-image: linear-gradient(90deg,#c80000 0%, #ff0000 52%,#c80000 100%),linear-gradient( #ffe6c4,#ffe6c4);background-blend-mode: normal,normal;line-height: 22px; border-radius: 4px; color: white;cursor: pointer;">点亮</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  // 引入 ECharts 主模块
  const echarts = require('echarts/lib/echarts');
  require('echarts/lib/chart/map');
  // 引入提示框和标题组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/title');
  import {getlightupdata} from "@/api/recollection.js"
  import '../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
  import bs64 from '@/assets/js/bs64.js'

  export default {
    //显示的声明组件
    name: "echarts",
    //从父级组件中传值过来的！
    props: ['dataAll'],
    data() {
      return {
        lyicon: false,
        listofcities: [],
        province: [],
        mapdadian: [],
        mapdataly: [],
        region: "",
        value: "",
        mapdata: "",
        ismap: false,
        areay: {
          "北京": "110000000000",
          "天津": "120000000000",
          "河北": "130000000000",
          "山西": "140000000000",
          "内蒙古": "150000000000",
          "辽宁": "210000000000",
          "吉林": "220000000000",
          "黑龙江": "230000000000",
          "上海": "310000000000",
          "江苏": "320000000000",
          "浙江": "330000000000",
          "安徽": "340000000000",
          "福建": "350000000000",
          "江西": "360000000000",
          "山东": "370000000000",
          "河南": "410000000000",
          "湖北": "420000000000",
          "湖南": "430000000000",
          "广东": "440000000000",
          "广西": "450000000000",
          "海南": "460000000000",
          "重庆": "500000000000",
          "四川": "510000000000",
          "贵州": "520000000000",
          "云南": "530000000000",
          "西藏": "540000000000",
          "陕西": "610000000000",
          "甘肃": "620000000000",
          "青海": "630000000000",
          "宁夏": "640000000000",
          "新疆": "650000000000",
        },
        option: {
          title: {
            top: 40,
            text: '点亮小星星,让精神之光绽放',
            subtext:"( 国家级抗战纪念设施、遗址点位示意)",
            x: 'center',
            textStyle: {
              color: '#990000',
              fontStyle: 'normal',
              fontWeight: 'bold',
              fontFamily: 'sans-serif',
              fontSize: 25
            },
            subtextStyle: {
              //文字颜色
              color: '#990000',
              fontStyle: 'normal',
              fontWeight: 'bold',
              fontFamily: 'sans-serif',
              fontSize: 18
            }
          },
          tooltip: {
            triggerOn: 'click',
            enterable: true,
            backgroundColor: 'rgba(0,0,0,0)',//通过设置rgba调节背景颜色与透明度
            formatter: (e, t, n) => {
              this.mapdata = e
            }
          }, // 鼠标移到图里面的浮动提示框
          dataRange: {
            show: false,
            min: 0,
            max: 1000,
            text: ['High', 'Low'],
            realtime: true,
            calculable: true,
            color: ['#ffe3e3', '#ed2c2b']
          },
          geo: {
            map: 'china',
            show: true,
            roam: false,
            label: {
              emphasis: {
                show: false
              }
            },
            zoom: 1.2,
            itemStyle: {
              normal: {
                borderWidth: 3,
                shadowOffsetY: 0,
                shadowBlur: 60,
                areaColor: '#ffe3e3',
                shadowColor: '#dda364',//外发光
                borderColor: '#cea288',
              },
            }
          },
          series: [
            {
              name: "map",
              type: 'map',
              map: 'china',
              aspectScale: 0.75,
              zoom: 1.2,
              label: {
                normal: {
                  show: true
                },
                emphasis: {
                  show: true,
                }
              },
              itemStyle: {
                normal: {
                  areaColor: '#ffe3e3',
                  borderColor: '#cea288',
                },
                emphasis: {
                  areaColor: '#f19b9b',
                  shadowColor: '#ed2c2b',
                  shadowOffsetX: -5,
                  shadowOffsetY: 15,
                  shadowBlur: 10,
                }
              }
            },
            {
              name: '散点',
              type: 'effectScatter',
              rippleEffect: {
                period: 15,
                scale: 2.5,
                brushType: 'fill'
              },
              hoverAnimation: true,
              coordinateSystem: 'geo',
              symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAB6ElEQVQ4T5XSv2uTURTG8e95k3tTF1HI3DEipaA2NwoiVKRDpeB/IO3moilUFLTSSovQ0kKjS7eK4CoI4g8cHKSguakKUjAODp0DOohN3re+R/KalEabiHe5wz3nw73PuUKPVc8zGghzItw0ZV50K5VeSOj4CNwDLlvP4H8jkWNa4aL15ELHZ4EHxjO/H9T1JpGjpsq8rbAS5pkUYdp4sj0RHSYdfWdQA44SkxPhgvUcbzeFjveqPE7BpxiqRqnKBj+a59IosCgxYwg5IAV8RdgMYCFd5kkb2SkwFsN1lAHgMCRANYaHEjpUhKko5u2B33qtV9jNMx0iuy0cMQEnVVmWVoBzwIT13P8XsOd548CawK0k2NBxBSgBk9Yne88VOorAClC0nru709lxjMewpsrtTIXZbkojz6wIMwFMpFs37xhxVGBRFWc9Z7shoeOVCN6Uudau6UQcT1XYsmUudUUKrIrSbzzn90Uaji2B5XYuOoSpC6f7lHXZIGrlV1SYynj6/0J0lExUox7DyM+YTStcVUkCfA2cEaUUKkupgIEAXposffKMRvLZdkdWII/yRuCOkjS/E1gwnufbeYZTwgxwQqCkcAPhlC1T6UD0GIciw7rAl+aUMp5Hf+ayBztoIs7JB741a34BuSauiw7ufa0AAAAASUVORK5CYII=\n',
              symbolSize: [15, 15],
              itemStyle: {
                normal: {
                  color: '#D8BC37' //标志颜色
                }
              },
              label: {
                normal: {
                  formatter: '{b}',
                  position: 'right',
                  show: false,
                }
              },
              data: undefined,
              showEffectOn: 'render',
              hoverAnimation: true,
              zlevel: 1
            },
            {
              name: '散点亮',
              type: 'scatter',
              coordinateSystem: 'geo',
              symbol: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAABaUlEQVQ4T53TPyxDURTH8e959Z6GGImhwmSUlPew+LeIxCAmm3QRC4ORhc1mYhGJhGAxGCwsFoP0taSDWCQkGjNJg77qvdKmSquvTd31nvPJvb97rlBleQ67wKTOMtJ4zZ1fqfhteIMMkOWqsB+3XOz6EZsEQk+xUdNrxbipBFU8yUcf44bB2e8GDWeNLhO+iA7TmjHoUELIEELADDBc3iCwrCCpNMmg5olXknJPWgrhRaoFXCWLZxHmc8gD0PUfJNejNEvyaTOlhEOgqW5I2LeizOaDzQwwphSHAu11QFuWy0Kuvvg6Xj82mgOguxYksG66rHzXlTyx57ANzNVCzDda5JaUHxIFnFqIKIbMOJcVkYxDSkNzLURpFoMxNv8g72E6Aw08lkyp5kiEc2C1bAx2LPfn2sVM3m1GA8JFHtHsYbBhRUl8o55DbiDzmGhOzBjTFa+TtlkTg1MrSsz3dztEXt44bvsV7BcS12orvGnrSAAAAABJRU5ErkJggg==",
              symbolSize: [25, 25],
              itemStyle: {
                normal: {
                  color: '#D8BC37', //标志颜色
                }
              },
              data: [],
              showEffectOn: 'render',
              hoverAnimation: true,
              zlevel: 1
            },
          ]
        }
      }
    },

    watch: {
      dataAll: function (newdata, olddata) {
        this.handlMapList()
        this.mapEchartsInit();
      }
    },
    mounted() {

    },
    methods: {
      mousewheel(data) {
        this.$emit('mousewheelpm', data)
      },
      mapEchartsInit() {
        var myChart = echarts.init(this.$refs.map);
        myChart.setOption(this.option, true);
      },
      handldGetMousePos(event) {
        var e = event || window.event;
        let all = this.option.series[2].data;
        if (this.mapdata) {
          if (this.mapdata.seriesName == "散点") {
            let text = "您 &nbsp;&nbsp; 刚刚为&nbsp;" + this.mapdata.data.name + "&nbsp;点亮一颗小星星"
            let mmshName = this.mapdata.data.mmshName
            let data = {
              'id': this.mapdata.data.mmshGuid
            };
            all.push(this.mapdata.data);
            this.option.series[2].data = all;
            this.mapEchartsInit()
            this.province.forEach((item) => {
              if (item.name == mmshName) {
                item.dl = true
              }
            });
            getlightupdata(data).then((res) => {
              if (res.code == 200) {
                this.$emit('handleCemetery', this.mapdata.data)
              }
            }).catch(() => {

            })
            this.$emit('realtimebox', text)
          } else if (this.mapdata.seriesName == "散点亮") {
            this.$emit('handleCemetery', this.mapdata.data)
          } else if (this.mapdata.seriesName == "map") {
            if (this.mapdata.name) {
              var name = this.mapdata.name
              this.listofcities = this.province.filter((item) => {
                if (item.city.indexOf(name) >= 0) {
                  return item
                } else {

                }
              })
            }
            this.ismap = true
            this.region = this.mapdata.name
            this.value = this.mapdata.value
            this.$refs.maptc.style.left = e.offsetX+20 + "px"
            this.$refs.maptc.style.top = e.offsetY -(e.offsetY*0.5)  + "px"

          }
          this.mapdata = null
        } else {
          this.ismap = false
        }
      },
      handlMapList() {
        let data = [];
        for (var key in this.areay) {
          let regionalcity = this.dataAll[(this.areay[key])]
          if (regionalcity)
            for (var i = 0; i < regionalcity.length; i++) {
              this.province.push({
                city: (regionalcity[i].mmshSheng),
                name: (regionalcity[i].mmshName),
                value: [regionalcity[i].mmshJingdu, regionalcity[i].mmshWeidu],
                mmshGuid: (regionalcity[i].mmshGuid),
                mmshName: (regionalcity[i].mmshName),
                mmshPicDamen: (regionalcity[i].mmshPicDamen),
                mmshLikeNum: (regionalcity[i].mmshLikeNum),
                dl: false
              })
            }
        }
        this.option.series[1].data = this.province;
      },
      handleLittleStar(item) {
        let text = "您 &nbsp;&nbsp; 刚刚为&nbsp;" + item.name + "&nbsp;点亮一颗小星星"
        let mmshName = item.mmshName
        let all = this.option.series[2].data;
        let data = {
          'id': item.mmshGuid
        };
        all.push({name: item.mmshName, value: item.value});
        this.option.series[2].data = all;
        this.mapEchartsInit()
        this.province.forEach((item) => {
          if (item.name == mmshName) {
            item.dl = true
          }
        });
        getlightupdata(data).then((res) => {
          this.$emit('handleCemetery', item)
          this.$emit('realtimebox', text)
        }).catch(() => {

        })
      },
      handleEnter(item) {
        let all = this.option.series[2].data;
        all.unshift({name: item.mmshName, value: item.value});
        this.option.series[2].data = all;
        this.mapEchartsInit()
      },
      handleLeave(item) {
        let all = this.option.series[2].data;
        all.shift(all[0])
        this.option.series[2].data = all;
        this.mapEchartsInit()
      },


    },

    computed: {}
  }
</script>
<style scoped>
  .map-click-tc {
    width: 311px;
    height: 206.5px;
    background-color: #ffe6c4;
    box-shadow: 3px 4px 14px 1px rgba(159, 97, 0, 0.5);
    border-radius: 8px;
    border: solid 1px #c2894c;
  }

  .ly-icon-wdl {
    background: url("../assets/img/wjxb.png");
  }
  .ly-icon-dl {
    background: url("../assets/img/wjxh.png");
  }
  .ly-name {
    cursor: pointer;
  }
  .roll-li {
    margin-bottom: 10px;
  }

  .roll-ul {
    width: 100%;
    max-height: 80%;
    padding: 0 10px;
    box-sizing: border-box;
    overflow-y: auto;
  }



</style>




// WEBPACK FOOTER //
// src/components/echarts.vue